import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import moment from "moment";
import _ from "lodash";

/*- utilities -*/
function updateNumeroAlumnos({ idColegio, idActividad }) {
  return dispatch =>
    rootRef
      .child(`alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}`)
      .orderByChild("baja")
      .equalTo(false)
      .once("value", snap => {
        let insert = {};
        insert[
          `actividades_por_colegio/${idColegio}/${idActividad}/alumnos`
        ] = snap.numChildren();
        rootRef.update(insert);
      });
}

/*- operations -*/
function setAsignacionData(datos) {
  return actions.setAsignacionData(datos);
}

function resetAsignacionData() {
  return actions.resetAsignacionData();
}

function obtenerActividadesAsignadas(idColegio) {
  return dispatch => {
    dispatch(onAddedActividadAsignada(idColegio));
    dispatch(onChangedActividadAsignada(idColegio));
    dispatch(onRemovedActividadAsignada(idColegio));
  };
}

function onAddedActividadAsignada(idColegio) {
  return dispatch =>
    rootRef
      .child(`actividades_por_colegio/${idColegio}`)
      .on("child_added", snap =>
        dispatch(actions.obtenerActividadesAsignadas(snap.val()))
      );
}

function onChangedActividadAsignada(idColegio) {
  return dispatch =>
    rootRef
      .child(`actividades_por_colegio/${idColegio}`)
      .on("child_changed", snap =>
        dispatch(actions.cambiarActividadesAsignadas(snap.val()))
      );
}

function onRemovedActividadAsignada(idColegio) {
  return dispatch =>
    rootRef
      .child(`actividades_por_colegio/${idColegio}`)
      .on("child_removed", snap =>
        dispatch(actions.eliminarActividadesAsignadas(snap.val()))
      );
}

function detachActividadesAsignadas(idColegio) {
  return dispatch =>
    rootRef.child(`actividades_por_colegio/${idColegio}`).off();
}

function resetActividadesAsignadas(idColegio) {
  return actions.resetActividadesAsignadas();
}

function updateActividadAsignada(info) {
  const { idColegio, idActividadAsignada, name, value } = info;
  let insert = {};

  name === "fechaFin" &&
    (insert[
      `actividades_por_colegio/${idColegio}/${idActividadAsignada}/finalizada`
    ] = moment(value, "YYYYMMDD").isValid());

  insert[
    `actividades_por_colegio/${idColegio}/${idActividadAsignada}/${name}`
  ] = value;

  return dispatch => rootRef.update(insert);
}

function saveAsignacionActividades(datos) {
  let data = {};
  data["fechaIni"] = moment().format("YYYYMMDD");
  data["fechaFin"] = "-";
  data["actividad"] = datos.nombre;
  data["idActividad"] = datos.id;
  data["colegio"] = datos.nombreColegio;
  data["idColegio"] = datos.idColegio;
  data["importe"] = datos.importe;
  data["noAmpa"] = 0;
  data["noColegio"] = 0;
  data["descuento"] = 0;
  data["alumnos"] = 0;
  data["finalizada"] = false;

  let insert = {};
  const key = rootRef.child(`actividades_por_colegio/${datos.idColegio}`).push()
    .key;
  data.id = key;
  insert[`actividades_por_colegio/${datos.idColegio}/${key}`] = data;

  return dispatch => rootRef.update(insert);
}

function detachAlumnosAsignados({ idColegio, idActividad }) {
  return dispatch =>
    rootRef
      .child(`alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}`)
      .off();
}

function obtenerAlumnosAsignados(values) {
  return dispatch => {
    dispatch(onAddedAlumnosAsignados(values));
    dispatch(onChangedAlumnosAsignados(values));
    dispatch(onRemovedAlumnosAsignados(values));
  };
}

function onAddedAlumnosAsignados({ idColegio, idActividad }) {
  return dispatch =>
    rootRef
      .child(`alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}`)
      .on("child_added", snap => {
        let info = snap.val();
        info.key = snap.key;

        rootRef.child(`detalles/alumnos/${info.idAlumno}`).on("value", snap => {
          let payload = snap.val();
          payload["fechaAlta"] = info.fechaAlta;
          payload["fechaBaja"] = info.fechaBaja;
          payload["key"] = info.key;
          payload["id"] = info.idAlumno;

          dispatch(actions.obtenerAlumnosAsignados(payload));
        });
      });
}

function onChangedAlumnosAsignados({ idColegio, idActividad }) {
  return dispatch =>
    rootRef
      .child(`alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}`)
      .on("child_changed", snap => {
        let info = snap.val();
        info.key = snap.key;

        rootRef.child(`detalles/alumnos/${info.idAlumno}`).on("value", snap => {
          let payload = snap.val();
          payload["fechaAlta"] = info.fechaAlta;
          payload["fechaBaja"] = info.fechaBaja;
          payload["key"] = info.key;
          dispatch(actions.cambiarAlumnosAsignados(payload));
        });
      });
}

function onRemovedAlumnosAsignados({ idColegio, idActividad }) {
  return dispatch => {
    rootRef
      .child(`alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}`)
      .on("child_removed", snap => {
        dispatch(actions.eliminarAlumnosAsignados(snap.key));
      });
  };
}

function resetAlumnosAsignados() {
  return actions.resetAlumnosAsignados();
}

function altaAlumnoActividad(values) {
  const { idColegio, idActividad } = values;

  let insert = {};
  const path = `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/`;
  const key = rootRef.child(path).push().key;
  insert[
    `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${key}`
  ] = values;

  return dispatch =>
    rootRef.update(insert, () =>
      dispatch(updateNumeroAlumnos({ idColegio, idActividad }))
    );
}

function bajaAlumnoActividad({ idColegio, idActividad, keyAlumno, fechaBaja }) {
  let insert = {};
  insert[
    `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${keyAlumno}/fechaBaja`
  ] = fechaBaja;

  insert[
    `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${keyAlumno}/baja`
  ] = true;

  return dispatch =>
    rootRef.update(insert, () =>
      dispatch(updateNumeroAlumnos({ idColegio, idActividad }))
    );
}

function tramitarBajaAlumno(values) {
  return dispatch => {
    const {
      nombre,
      apellido1,
      apellido2,
      actividad,
      idActividad,
      nombreColegio,
      idColegio,
      keyAlumno,
      fechaBaja
    } = values;

    const idBaja = rootRef.child("extraescolares/bajas").push().key;

    let insert = {};
    insert[`extraescolares/bajas/${idBaja}`] = {
      nombreAlumno: nombre,
      apellido1,
      apellido2,
      actividad,
      idActividad,
      nombreColegio,
      idColegio,
      idAlumno: keyAlumno,
      fechaBaja,
      idBaja
    };

    rootRef.update(insert);
  };
}

function altaCobroActividad(info) {
  return dispatch => {
    const { idAlumno, idColegio, idActividad } = info;
    let prom = [];
    prom.push(rootRef.child(`detalles/alumnos/${idAlumno}`).once("value"));
    prom.push(rootRef.child(`detalles/colegios/${idColegio}`).once("value"));
    prom.push(
      rootRef
        .child(`actividades_por_colegio/${idColegio}/${idActividad}`)
        .once("value")
    );
    prom.push(rootRef.child(`cobros/general/${idAlumno}`).once("value"));

    Promise.all(prom)
      .then(respuestas => {
        const alumno = respuestas[0].val();
        const colegio = respuestas[1].val();
        const actividadColegio = respuestas[2].val();
        const cobroAlumno = respuestas[3].val();
        let nActividades = {};
        let total = 0;
        let concepto = "";

        if (cobroAlumno !== null) {
          const { actividades } = cobroAlumno;
          nActividades = _.cloneDeep(actividades);
          concepto = "V.Actividades";
          total = cobroAlumno.importeFinal;
        } else {
          concepto = actividadColegio.actividad;
        }

        total += parseFloat(actividadColegio.importe);
        !alumno.ampa && (total += parseFloat(actividadColegio.noAmpa));
        alumno.hermano && (total -= parseFloat(actividadColegio.descuento));

        nActividades[idActividad] = {
          alta: true,
          baja: false,
          actividad: actividadColegio.actividad,
          precio: actividadColegio.importe,
          noAmpa: actividadColegio.noAmpa,
          noColegio: actividadColegio.noColegio,
          descuento: actividadColegio.descuento,
          idActividad: actividadColegio.idActividad
        };

        let datos = {
          fechaCobro: "",
          idAlumno,
          alumnoNombre: alumno.nombre,
          alumnoApellidos: `${alumno.apellido1} ${alumno.apellido2}`,
          iban: alumno.iban || "Falta IBAN",
          idColegio,
          colegio: colegio.nombre,
          concepto,
          importeFinal: total,
          actividades: nActividades,
          ampa: alumno.ampa || false
        };

        rootRef
          .child(`detalles/actividades/${actividadColegio.idActividad}`)
          .once("value", sn => {
            const activ = sn.val();
            let data = {
              [idColegio]: colegio.nombre,
              [actividadColegio.idActividad]: activ.nombre
            };

            let insert = {};
            insert[`cobros/general/${idAlumno}`] = datos;
            insert[
              `alumno_actividad/${idAlumno}/${actividadColegio.idActividad}`
            ] = data;
            rootRef.update(insert);
          });
      })
      .catch(error => console.log(error));
  };
}

function bajaCobroActividad({ keyAlumno, idColegio, idActividad }) {
  return dispatch => {
    rootRef
      .child(
        `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${keyAlumno}`
      )
      .once("value", snap => {
        const { idAlumno, baja: esBaja } = snap.val();
        if (idAlumno !== null) {
          let prom = [];
          prom.push(
            rootRef.child(`detalles/alumnos/${idAlumno}`).once("value")
          );
          prom.push(
            rootRef.child(`detalles/colegios/${idColegio}`).once("value")
          );
          prom.push(
            rootRef
              .child(`actividades_por_colegio/${idColegio}/${idActividad}`)
              .once("value")
          );
          prom.push(rootRef.child(`cobros/general/${idAlumno}`).once("value"));

          Promise.all(prom)
            .then(respuestas => {
              const alumno = respuestas[0].val();
              const colegio = respuestas[1].val();
              const actividadColegio = respuestas[2].val();
              const cobroAlumno = respuestas[3].val();
              let nActividades = {};
              let total = 0;
              let concepto = "";

              if (cobroAlumno === null) {
                return;
              }

              const { actividades } = cobroAlumno;
              total = cobroAlumno.importeFinal;
              let resta = parseFloat(actividadColegio.importe);
              !alumno.ampa && (resta += parseFloat(actividadColegio.noAmpa));
              alumno.hermano &&
                (resta -= parseFloat(actividadColegio.descuento));
              nActividades = _.cloneDeep(actividades);
              nActividades[idActividad] = {
                alta: false,
                baja: true,
                actividad: actividadColegio.actividad,
                precio: actividadColegio.importe,
                noAmpa: actividadColegio.noAmpa,
                noColegio: actividadColegio.noColegio,
                descuento: actividadColegio.descuento,
                idActividad: actividadColegio.idActividad
              };
              let actividadesOK = 0;
              _.forOwn(actividades, (v, k) => {
                idActividad !== k && (v.alta && actividadesOK++);
                concepto = actividadesOK > 1 ? "V.Actividades" : v.actividad;
              });

              let datos = {
                fechaCobro: "",
                idAlumno,
                alumnoApellidos: `${alumno.apellido1} ${alumno.apellido2}`,
                alumnoNombre: alumno.nombre,
                iban: alumno.iban || "Falta IBAN",
                idColegio,
                colegio: colegio.nombre,
                concepto,
                importeFinal: !esBaja ? total - resta : total,
                actividades: nActividades
              };

              let insert = {};
              insert[`cobros/general/${idAlumno}`] = datos;
              insert[
                `alumno_actividad/${idAlumno}/${actividadColegio.idActividad}`
              ] = null;
              rootRef.update(insert);
            })
            .catch(error => console.log(error));
        }
      });
  };
}

function updateAlumnoActividad(info) {
  const { idColegio, idActividad, keyAlumno, fechaAlta } = info;
  let insert = {};

  insert[
    `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${keyAlumno}/fechaAlta`
  ] = fechaAlta;

  const fechaNueva = moment(fechaAlta, "YYYYMMDD");
  const hoy = moment();
  const continua = moment(fechaNueva).isBefore(hoy, "month");

  insert[
    `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${keyAlumno}/alta`
  ] = !continua;

  return dispatch => {
    rootRef
      .child(
        `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${keyAlumno}`
      )
      .once("value", snap => {
        const { idAlumno } = snap.val();

        insert[
          `cobros/general/${idAlumno}/actividades/${idActividad}/alta`
        ] = !continua;

        rootRef.update(insert);
      });
  };
}

function eliminarAlumnoActividad(info) {
  const { keyAlumno, idAlumno, idColegio, idActividad } = info;
  let insert = {};
  insert[
    `alumnos_por_actividad_y_colegio/${idColegio}/${idActividad}/${keyAlumno}`
  ] = null;
  insert[`cobros/general/${idAlumno}/actividades/${idActividad}`] = null;

  return dispatch => {
    rootRef.update(insert, () => {
      let prom = [];
      prom.push(rootRef.child(`cobros/general/${idAlumno}`).once("value"));
      prom.push(
        rootRef
          .child(`actividades_por_colegio/${idColegio}/${idActividad}`)
          .once("value")
      );

      Promise.all(prom)
        .then(resp => {
          const alumno = resp[0].val();
          const act = (alumno && alumno.actividades) || null;
          let insert = {};

          if (!_.isEmpty(act)) {
            const size = Object.keys(act).length;

            switch (size) {
              case 0:
                insert[`cobros/general/${idAlumno}`] = null;
                break;

              case 1:
                const activ = Object.keys(act)[0];

                insert[`cobros/general/${idAlumno}/concepto`] = Object.values(
                  act
                )[0].actividad;
                insert[`cobros/general/${idAlumno}/importeFinal`] =
                  parseFloat(act[activ].precio) +
                  parseFloat(act[activ].noAmpa) +
                  parseFloat(act[activ].noColegio) -
                  parseFloat(act[activ].descuento);
                break;

              default:
                insert[`cobros/general/${idAlumno}/concepto`] = "V.Actividad";

                let importeFinal = 0;
                _.forOwn(act, (v, k) => {
                  importeFinal =
                    parseFloat(importeFinal) +
                    parseFloat(v.precio) +
                    parseFloat(v.noAmpa) +
                    parseFloat(v.noColegio) -
                    parseFloat(v.descuento);
                });

                insert[
                  `cobros/general/${idAlumno}/importeFinal`
                ] = importeFinal;
                break;
            }
          } else {
            insert[`cobros/general/${idAlumno}`] = null;
          }

          const idAct = resp[1].val().idActividad;
          insert[`alumno_actividad/${idAlumno}/${idAct}`] = null;

          rootRef.update(insert, () =>
            dispatch(updateNumeroAlumnos({ idColegio, idActividad }))
          );
        })
        .catch(error => console.log(error));
    });
  };
}

/*---*/
export {
  setAsignacionData,
  resetAsignacionData,
  obtenerActividadesAsignadas,
  resetActividadesAsignadas,
  detachActividadesAsignadas,
  updateActividadAsignada,
  saveAsignacionActividades,
  detachAlumnosAsignados,
  obtenerAlumnosAsignados,
  resetAlumnosAsignados,
  altaAlumnoActividad,
  altaCobroActividad,
  bajaCobroActividad,
  bajaAlumnoActividad,
  updateAlumnoActividad,
  eliminarAlumnoActividad,
  tramitarBajaAlumno
};



// WEBPACK FOOTER //
// ./src/ducks/asignaciones/operations.js